import { useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';

import { getFragment } from '../../../graphql/client/helpers/get-fragment';
import { GetPrescriberOrderDocument } from '../../../graphql/generated/graphql';
import { useFlags } from '../../../hooks/use-flags';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';
import { Loader } from '../../common/Loader';

import { RenewalStatus } from './RenewalStatus';

const RenewalStatusPage = () => {
    const { prescriberOrderId } = useParams();
    const { enableRxRenewalLilly } = useFlags();
    const { data, loading } = useQuery(GetPrescriberOrderDocument, {
        variables: { prescriberOrderId: prescriberOrderId ?? '' },
        skip: !prescriberOrderId,
    });

    if (!enableRxRenewalLilly) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    if (loading) {
        return <Loader />;
    }

    if (!prescriberOrderId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const prescriberOrder = getFragment(data?.prescriberOrderV2);
    if (!prescriberOrder) {
        return <Navigate to={getAbsoluteRoute('notFound')} />;
    }

    if (prescriberOrder.__typename !== 'DigitallyReceivedPrescriberOrder') {
        return (
            <Navigate
                to={getAbsoluteRoute('order.prescriberOrderId.verifyPatient', {
                    prescriberOrderId,
                })}
            />
        );
    }

    return <RenewalStatus prescriberOrder={prescriberOrder} />;
};

export default RenewalStatusPage;
